/* Oxomi Integration for Product Pages */
(function() {
  let observer;
  let hasOxomiPages = false;
  let hasOxomiVideos = false;
  let hasOxomiAttachments = false;
  let hasOxomiReferences = false;

  function initOxomiIntegration() {
    const oxomiContainer = document.querySelector('[data-oxomi-container]');
    if (!oxomiContainer) return;

    const productData = JSON.parse(oxomiContainer.dataset.oxomiData || '{}');
    if (!productData.itemNumber) return;

    const oxomiPages = document.getElementById('oxomiPages');
    const oxomiVideos = document.getElementById('oxomiVideos');
    const oxomiAttachments = document.getElementById('oxomiAttachments');
    const oxomiReferences = document.getElementById('oxomiReferences');

    // Setup mutation observers
    observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        const target = mutation.target;

        if (target.id === 'oxomiPages' && mutation.addedNodes.length) {
          hasOxomiPages = true;
          updateVisibility();
        } else if (target.id === 'oxomiVideos' && mutation.addedNodes.length) {
          hasOxomiVideos = true;
          updateVisibility();
        } else if (target.id === 'oxomiAttachments' && mutation.addedNodes.length) {
          hasOxomiAttachments = true;
          updateVisibility();
        } else if (target.id === 'oxomiReferences' && mutation.addedNodes.length) {
          hasOxomiReferences = true;
          updateVisibility();
        }
      });
    });

    // Observe all containers
    [oxomiPages, oxomiVideos, oxomiAttachments, oxomiReferences].forEach(el => {
      if (el) {
        observer.observe(el, { childList: true, subtree: true });
      }
    });

    // Handle reference clicks
    if (oxomiReferences) {
      oxomiReferences.addEventListener('click', handleReferenceClick);
    }

    // Load Oxomi script
    loadOxomiScript();
  }

  function updateVisibility() {
    const container = document.querySelector('[data-oxomi-container]');
    if (!container) return;

    const hasContent = hasOxomiPages || hasOxomiVideos || hasOxomiAttachments || hasOxomiReferences;
    container.style.display = hasContent ? 'block' : 'none';

    // Show/hide individual sections
    const pagesHeader = document.querySelector('[data-oxomi-pages-header]');
    if (pagesHeader) pagesHeader.style.display = hasOxomiPages ? 'block' : 'none';

    const videosHeader = document.querySelector('[data-oxomi-videos-header]');
    if (videosHeader) videosHeader.style.display = hasOxomiVideos ? 'block' : 'none';

    const attachmentsHeader = document.querySelector('[data-oxomi-attachments-header]');
    if (attachmentsHeader) attachmentsHeader.style.display = hasOxomiAttachments ? 'block' : 'none';

    const referencesHeader = document.querySelector('[data-oxomi-references-header]');
    if (referencesHeader) referencesHeader.style.display = hasOxomiReferences ? 'block' : 'none';
  }

  function handleReferenceClick(event) {
    const target = event.target.closest('.oxomi-reference');
    if (!target) return;

    const itemNumber = target.querySelector('.oxomi-reference-details-box .oxomi-block')?.textContent;
    const shortText = target.querySelector('.oxomi-reference-details-box .oxomi-reference-shorttext')?.textContent;

    if (itemNumber && shortText) {
      window.location.href = '/search?q=' + encodeURIComponent(itemNumber + ' ' + shortText);
    }
  }

  function loadOxomiScript() {
    const existingScript = document.querySelector('script[src="https://oxomi.com/assets/frontend/v2/oxomi.js"]');

    if (!existingScript) {
      const script = document.createElement('script');
      script.src = 'https://oxomi.com/assets/frontend/v2/oxomi.js';
      script.async = false;
      document.body.appendChild(script);

      document.addEventListener('oxomi-loaded', setupOxomiConnector);
      document.addEventListener('oxomi-configured', injectProductData);
    } else {
      // Script already loaded, inject data directly
      injectProductData();
    }
  }

  function setupOxomiConnector() {
    try {
      if (typeof buzz === 'undefined') return;

      const shop = new buzz.Connector({
        name: 'SHOP'
      });

      // Handle product data fetching
      shop.addCapability('fetchProductData', async function(message) {
        const product = message.payload();
        // Return empty for now - can be enhanced later
        message.reply({ products: [] });
      });

      // Jump to product label
      shop.addCapability('provideJumpToProductLabel', function(message) {
        message.reply({ label: 'Zum Produkt' });
      });

      // Jump to product functionality
      shop.addCapability('jumpToProduct', function(message) {
        const product = message.payload().product;
        if (product.gtin) {
          window.location.href = '/search?q=' + encodeURIComponent(product.gtin);
        } else if (typeof oxomi !== 'undefined') {
          oxomi.showMessageInDialog('', 'Produkt nicht gefunden.');
        }
      });

      // Add to cart functionality
      shop.addCapability('addProductToBasket', async function(message) {
        const product = message.payload().product;

        // Here you would integrate with Shopify cart
        // For now, show a message
        if (typeof oxomi !== 'undefined') {
          oxomi.showMessageInDialog(
            '',
            product.order.quantity + "x '" + product.itemNumber + "' - Warenkorb-Integration erforderlich."
          );
        }
      });

      // Initialize Oxomi
      if (typeof oxomi !== 'undefined') {
        oxomi.init({
          portal: '3001049',
          disableOverlayHistory: 'true'
        });
      }
    } catch (error) {
      console.error('Oxomi connector setup error:', error);
    }
  }

  function injectProductData() {
    const oxomiContainer = document.querySelector('[data-oxomi-container]');
    if (!oxomiContainer || typeof oxomi === 'undefined') return;

    const productData = JSON.parse(oxomiContainer.dataset.oxomiData || '{}');

    oxomi.productData({
      products: [{
        itemNumber: productData.itemNumber,
        supplierNumber: productData.supplierNumber,
        gtin: productData.gtin
      }],
      information: {
        videos: {
          target: '#oxomiVideos'
        },
        pages: {
          target: '#oxomiPages',
          limit: 10
        },
        attachments: {
          target: '#oxomiAttachments'
        },
        relationships: {
          target: '#oxomiReferences'
        },
        'bim-3d': {
          target: '#oxomiBim3D'
        }
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOxomiIntegration);
  } else {
    initOxomiIntegration();
  }

  // Listen for Oxomi variant change event dispatched from global.js
  const oxomiContainer = document.querySelector('[data-oxomi-container]');
  if (oxomiContainer) {
    oxomiContainer.addEventListener('oxomi:variant-changed', function(event) {
      console.log('Oxomi: variant changed', event.detail);

      // Reset flags
      hasOxomiPages = false;
      hasOxomiVideos = false;
      hasOxomiAttachments = false;
      hasOxomiReferences = false;

      // Hide container while reloading
      oxomiContainer.style.display = 'none';

      // Clear containers
      ['oxomiPages', 'oxomiVideos', 'oxomiAttachments', 'oxomiReferences', 'oxomiBim3D'].forEach(id => {
        const el = document.getElementById(id);
        if (el) el.innerHTML = '';
      });

      // Reinject data with new variant information
      setTimeout(() => {
        injectProductData();
      }, 100);
    });
  }

  // Cleanup on page unload
  window.addEventListener('beforeunload', function() {
    if (observer) {
      observer.disconnect();
    }
  });
})();
